import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CasesService } from 'src/app/core/services/cases.service';
import { TaskCaseService } from 'src/app/modules/case/services/taskCase.service';

@Component({
  selector: 'detalle-transaccional-del-caso',
  templateUrl: './detalle-transaccional-del-caso.component.html',
  styleUrls: ['./detalle-transaccional-del-caso.component.scss'],
})
export class DetalleTransaccionalDelCaso implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = [
    'Fecha de Ocurrencias', // Con hora
    'Monto Reclamado',
    'Comisión',
    'Cuenta Origen',
    'Cuenta de los Fondos Fraudulentos',
    'Beneficiario',
    'C.I. / RIF',
    'Fecha de Apertura',
    'Código de Oficina',
    'Oficina Apertura',
    'Opciones',
  ];
  dataSource = new MatTableDataSource<any>();
  tableValues: any[] = [];

  formTable: FormGroup;
  form: FormGroup;
  submit = false;

  @Input() data: { task: any };

  constructor(
    private fb: FormBuilder,
    public taskCaseService: TaskCaseService,
    private caseService: CasesService
  ) {}
  icase;
  get status() {
    return this.icase?.status == 'archived';
  }
  ngOnInit(): void {
    let caseId: any;
    if (typeof this.data.task.case == 'object') {
      caseId = this.data.task.case._id;
    } else if (typeof this.data.task.case == 'string') {
      caseId = this.data.task.case;
    }
    this.caseService.getCase(caseId).subscribe((res) => {
      this.icase = res;
    });
    const { task } = this.data;
    let values = task.data ? task.data : {};
    console.log(values);
    if (values) this.tableValues = values.tableValues ? values.tableValues : [];

    this.formTable = this.fb.group({
      fecha_ocurrencias: ['', [Validators.required]],
      monto_reclamado: ['', [Validators.required]],
      comision: ['', [Validators.required]],
      cuenta_origen: [
        '',
        [Validators.required, Validators.pattern(/^[0-9]\d*$/)],
      ],
      cuenta_fondos_fraudulentos: [
        '',
        [Validators.required, Validators.pattern(/^[0-9]\d*$/)],
      ],
      beneficiario: ['', [Validators.required]],
      ci_rif: ['', [Validators.required]],
      fecha_apertura: ['', [Validators.required]],
      codigo_oficina: ['', [Validators.required]],
      oficina_apertura: ['', [Validators.required]],
    });

    this.form = this.fb.group({
      numero_sake: [values ? values.numero_sake : '', [Validators.required]],
      nombre_cliente: [
        values ? values.nombre_cliente : '',
        [Validators.required],
      ],
      fecha_creacion: [
        values ? values.fecha_creacion : '',
        [Validators.required],
      ],
      fecha_asignacion: [
        values ? values.fecha_asignacion : '',
        [Validators.required],
      ],
      fecha_solucion: [
        values ? values.fecha_solucion : '',
        [Validators.required],
      ],
      canal_utilizado: [
        values ? values.canal_utilizado : '',
        [Validators.required],
      ],
      unidad_responsable: [
        values ? values.unidad_responsable : '',
        [Validators.required],
      ],
      centro_costo: [values ? values.centro_costo : '', [Validators.required]],
    });

    this.initializeTable();
  }

  verificateInput(value: string) {
    return (
      this.formTable.get(value)?.invalid &&
      (this.formTable.get(value)?.dirty || this.formTable.get(value)?.touched)
    );
  }

  getFormValidationErrors(form: any) {
    console.log('form validation', form);
    Object.keys(form.controls).forEach((key) => {
      const controlErrors = form.get(key).errors;
      console.log(controlErrors);
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach((keyError) => {
          console.log(
            'Key control: ' + key + ', keyError: ' + keyError + ', err value: ',
            controlErrors[keyError]
          );
        });
      }
    });
  }

  addData() {
    this.getFormValidationErrors(this.formTable);
    if (this.formTable.invalid || this.submit) return;
    this.submit = true;
    this.tableValues.unshift(this.formTable.value);
    this.form.value.tableValues = this.tableValues;
    this.formTable.reset();
    this.initializeTable();

    //       this.initializeTable();
    // this.taskCaseService
    //   .updateTaskCase(this.data.task._id, { data: this.form.value })
    //   .subscribe(
    //     () => {
    //       this.formTable.reset();
    //       this.initializeTable();
    //     },
    //     (erorr) => {
    //       this.submit = false;
    //     }
    //   );
  }

  removeData(index: number) {
    this.tableValues.splice(index, 1);
    this.form.value.tableValues = this.tableValues;
    this.taskCaseService
      .updateTaskCase(this.data.task.tareacasoId, {
        data: this.form.value,
      })
      .subscribe(() => {
        this.initializeTable();
      });
  }

  initializeTable() {
    this.dataSource = new MatTableDataSource<any>(this.tableValues);
    this.dataSource.paginator = this.paginator;
    this.submit = false;
  }
}
